/**
 * Fire-and-forget POST to `/rest/visitor/ask-complete` after a stream
 * finishes. The backend looks up per-visitor signals and may issue a
 * short-lived cookie used by upstream rules.
 *
 * `keepalive: true` keeps the request alive across immediate navigation
 * (browsers terminate inflight fetches on page unload otherwise). Errors
 * are non-critical and intentionally swallowed — failure to ping has no
 * visible effect on the user.
 */
export const postAskComplete = () => {
    void fetch('/rest/visitor/ask-complete', {
        method: 'POST',
        credentials: 'include',
        keepalive: true,
    }).catch(() => { });
};
//# sourceMappingURL=postAskComplete.js.map